import { Button } from "@shared/ui/button";
import { Database, Plus } from "lucide-react";
import { FormattedMessage } from "react-intl";

export function TableEmpty({ onAdd }: { onAdd: () => void }) {
	return (
		<div className="flex flex-col items-center justify-center px-6 py-20 text-center">
			<div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-background ring-1 ring-foreground/10">
				<Database className="h-7 w-7 text-muted-foreground" />
			</div>
			<h3 className="mt-4 text-base font-semibold text-foreground">
				<FormattedMessage id="table.empty.title" defaultMessage="No records found" />
			</h3>
			<p className="mt-1 text-sm text-muted-foreground">
				<FormattedMessage
					id="table.empty.description"
					defaultMessage="Add your first record to get started"
				/>
			</p>
			<Button className="mt-5 rounded-lg cursor-pointer" onClick={onAdd}>
				<Plus className="h-4 w-4" />
				<FormattedMessage id="table.empty.action" defaultMessage="Add record" />
			</Button>
		</div>
	);
}
